import {
  AutocompleteListParams,
  AutocompleteResponse,
  AutocompleteTimezoneResponse,
  GetCompanyTeamsAssociatedToCompanyAutocompleteParams,
} from 'types/autocomplete'
import request from 'tools/request'

const baseUrl = 'autocomplete/'

export const STALE_TIME = 60 * 1000

export const listAutocompleteClients = async (
  params: AutocompleteListParams,
  opts?: { skipCurrencyFilter?: boolean }
) => {
  const data = await request
    .get<AutocompleteResponse>('autocomplete/clients', {
      params: params,
      skipCurrencyFilter: opts?.skipCurrencyFilter,
    } as Parameters<typeof request.get>[1] & { skipCurrencyFilter?: boolean })
    .then((res) => {
      return res.data
    })
  return data
}

export const listAutocompleteInvoiceClients = async (params: AutocompleteListParams) => {
  const data = await request
    .get<AutocompleteResponse>('autocomplete/invoiceClients', { params: params })
    .then((res) => {
      return res.data
    })
  return data
}

export const listAutocompleteInvoiceDebtors = async (params: AutocompleteListParams) => {
  const data = await request
    .get<AutocompleteResponse>('autocomplete/invoiceDebtors', { params: params })
    .then((res) => {
      return res.data
    })
  return data
}

export const listAutocompleteDebtors = async (params: AutocompleteListParams) => {
  const data = await request.get<AutocompleteResponse>('autocomplete/debtors', { params: params }).then((res) => {
    return res.data
  })
  return data
}

export const listAutocompleteClientOrBrokerDebtors = async (params: AutocompleteListParams) => {
  const data = await request
    .get<AutocompleteResponse>('autocomplete/clientOrBrokerDebtors', { params: params })
    .then((res) => {
      return res.data
    })
  return data
}

export const listAutocomplete = async (
  endpoint: string,
  params: AutocompleteListParams,
  opts?: { skipCurrencyFilter?: boolean }
) => {
  const data = await request
    .get<AutocompleteResponse>(baseUrl + endpoint, {
      params: params,
      skipCurrencyFilter: opts?.skipCurrencyFilter,
    } as Parameters<typeof request.get>[1] & { skipCurrencyFilter?: boolean })
    .then((res) => {
      return res.data
    })
  return data
}

export const listAutocompleteClientDebtors = async (params: AutocompleteListParams) => {
  const data = await request.get<AutocompleteResponse>('autocomplete/clientDebtors', { params: params }).then((res) => {
    return res.data
  })
  return data
}

export const listAutocompleteTerms = async (params: AutocompleteListParams) => {
  const data = await request.get<AutocompleteResponse>('autocomplete/terms', { params: params }).then((res) => {
    return res.data
  })
  return data
}

export const listAutocompleteTimezone = async (params: AutocompleteListParams) => {
  const data = await request
    .get<AutocompleteTimezoneResponse>('autocomplete/timezones', { params: params })
    .then((res) => {
      return res.data
    })
  return data
}

export const listAutocompleteUsers = async (params: AutocompleteListParams) => {
  const data = await request.get<AutocompleteResponse>('autocomplete/users', { params: params }).then((res) => {
    return res.data
  })
  return data
}

export const listAutocompleteClientsBrokers = async (params: AutocompleteListParams) => {
  const data = await request
    .get<AutocompleteResponse>('autocomplete/clientsBrokers', { params: params })
    .then((res) => {
      return res.data
    })
  return data
}

export const listAutocompleteInvoiceClientsBrokers = async (params: AutocompleteListParams) => {
  const data = await request
    .get<AutocompleteResponse>('autocomplete/invoiceClientsBrokers', { params: params })
    .then((res) => {
      return res.data
    })
  return data
}

export const listAutocompleteQuickPayFee = async (params: AutocompleteListParams) => {
  const data = await request.get<AutocompleteResponse>('autocomplete/quickPayFee', { params: params }).then((res) => {
    return res.data
  })
  return data
}

export const listAutocompleteRoles = async (params: AutocompleteListParams) => {
  const data = await request.get<AutocompleteResponse>('autocomplete/roles', { params: params }).then((res) => {
    return res.data
  })
  return data
}

export const listSalesExecutives = async (params: AutocompleteListParams) => {
  const data = await request
    .get<AutocompleteResponse>('autocomplete/sales-executive', { params: params })
    .then((res) => {
      return res.data
    })
  return data
}

export const fipsStateCode = async (params: AutocompleteListParams) => {
  const data = await request
    .get<AutocompleteResponse>('autocomplete/fips-state-code', { params: params })
    .then((res) => {
      return res.data
    })
  return data
}

export const fipsCountyCode = async (params: AutocompleteListParams) => {
  const data = await request
    .get<AutocompleteResponse>('autocomplete/fips-county-code', { params: params })
    .then((res) => {
      return res.data
    })
  return data
}

export const listAutocompleteCompaniesAssociatedToTeam = async (params: AutocompleteListParams) => {
  const data = await request
    .get<AutocompleteResponse>(`autocomplete/company-teams/${params.companyTeamId}/companies`, { params: params })
    .then((res) => {
      return res.data
    })
  return data
}

export const listAutocompleteTeamsAssociatedToCompany = async (
  params: GetCompanyTeamsAssociatedToCompanyAutocompleteParams
) => {
  const data = await request
    .get<AutocompleteResponse>(`autocomplete/company-teams/companies/${params.companyId}`, {
      params: params,
    })
    .then((res) => {
      return res.data
    })
  return data
}

export const listAccountExecutives = async (params: AutocompleteListParams) => {
  const data = await request
    .get<AutocompleteResponse>('autocomplete/account-executive', { params: params })
    .then((res) => {
      return res.data
    })
  return data
}

export const listAutocompleteCommissionPartners = async (params: AutocompleteListParams) => {
  const data = await request
    .get<AutocompleteResponse>('autocomplete/commission-partners', { params: params })
    .then((res) => {
      return res.data
    })
  return data
}

export const listAutocompleteCommissionTemplates = async (params: AutocompleteListParams) => {
  const data = await request
    .get<AutocompleteResponse>('autocomplete/commission-templates', { params: params })
    .then((res) => {
      return res.data
    })
  return data
}
